import { Pipe, PipeTransform } from '@angular/core';
import { getUrl, Resource } from '@ngxp/rest';

@Pipe({
	name: 'testIdFromResource',
	standalone: false,
})
export class TestIdFromResource implements PipeTransform {
	transform(value: Resource): string {
		return getUrl(value);
	}
}
